<script setup lang="ts">
import { computed } from "vue"
import accountType from "@/types/account";

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  title: string
  errors: {[key: string]: string[]}
  labels: string[]
  modelValue: accountType
  itemKeys: string[]
  required: boolean
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col cols="3">
      <h6 class="pt-2 pl-4">
        {{ title }}<span v-if="required" style="color: red">✴︎</span>
      </h6>
    </v-col>
    <v-col cols="9">
      <v-row>
        <v-col cols="2">
          <h6 class="pt-2 pl-4">{{ labels?.[0] }}</h6>
        </v-col>
        <v-col cols="4">
          <v-text-field
            class="small pt-2"
            v-model="modelValue[itemKeys[0]]"
            density="compact"
            :error-messages="props.errors[itemKeys[0]]"
          />
        </v-col>
        <v-col cols="2">
          <h6 class="pt-2 pl-4">{{ labels?.[1] }}</h6>
        </v-col>
        <v-col cols="4">
          <v-text-field
            class="small pt-2"
            v-model="modelValue[itemKeys[1]]"
            density="compact"
            :error-messages="props.errors[itemKeys[1]]"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
